import { Node, mergeAttributes } from "@tiptap/core";

const Video = Node.create({
  name: "video",
  group: "inline",
  inline: true,
  allowBase64: true,
  content: "inline*",
  atom: true,

  parseHTML() {
    return [
      {
        tag: 'div[data-type="video"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      {},
      [
        "video",
        {
          controls: "true",
          src: HTMLAttributes.src,
          style: "width: 250px; height: 150px;",
        },
      ],
      ["br"],
    ];
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      title: {
        default: null,
      },
    };
  },
});

const Pdf = Node.create({
  name: "pdf",
  group: "block",
  content: "inline*",
  atom: true,
  parseHTML() {
    return [
      {
        tag: 'div[data-type="pdf"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      {
        "data-type": "pdf",
        style: "border: 1px solid #ccc; padding: 10px;",
      },
      [
        "a",
        {
          href: HTMLAttributes.src,
          target: "_blank",
        },
        HTMLAttributes.title || "PDF",
      ],
    ];
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      title: {
        default: null,
      },
    };
  },
});

const ReplayMail = Node.create({
  name: "replaymail",
  group: "block",
  content: "block+",
  parseHTML() {
    return [
      {
        tag: "div.replaymail",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      {
        class: "replaymail p-2 fs-11 mt-3",
        contenteditable: "false",
        // style:
        //   " background-color: #f7f7f7; user-select:none",
      },
      0,
    ];
  },
});

const EditMail = Node.create({
  name: "replaymail",
  group: "block",
  content: "block+",
  parseHTML() {
    return [
      {
        tag: "div.replaymail",
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { class: "replaymail" }), 0];
  },
  addAttributes() {
    return {
      style: {
        default:
          "border-top: 0.5px solid #E7E9EB; background-color: #F6F9FD; margin-top: 30px; user-select: none; padding: 10px;",
        parseHTML: (element) => element.style.cssText,
        renderHTML: (attributes) => ({ style: attributes.style }),
      },
      contenteditable: {
        default: "false",
        parseHTML: (element) => element.getAttribute("contenteditable"),
        renderHTML: (attributes) => ({
          contenteditable: attributes.contenteditable,
        }),
      },
    };
  },
});

export { Video, Pdf, ReplayMail, EditMail };
